// extracted by mini-css-extract-plugin
module.exports = {"buttonCheckBox":"classes_buttonCheckBox__2L2Wq","questionFont":"classes_questionFont__3Idwn"};